import React from 'react'
import PropTypes from 'prop-types'
import CustomTooltip from './CustomTooltip'

/**
 * InfoTooltip – a tiny info icon that reveals a tooltip on hover/focus.  
 * Keeps forms clean by hiding optional helper text until requested.
 *
 * Props:
 *  • text – content inside the tooltip (string or React node)
 *  • placement – tooltip position (top|right|bottom|left)
 *  • id – DOM id of the tooltip overlay (optional)
 *  • className – additional classNames for the wrapper span (optional)
 *
 * Basic usage:
 *   <Field
 *     name="eventName"
 *     label="Event Name"
 *     component={SimpleField}
 *     tooltipText="This appears on the public event page."
 *   />
 *
 * Stand-alone usage (outside of Field):
 *   <div>
 *     Need more info? <InfoTooltip text="Lorem ipsum dolor sit amet…" />
 *   </div>
 */
const InfoTooltip = ({ text, placement = 'right', id = 'info-tooltip', className = '' }) => {
  if (!text) return null
  return (
    <CustomTooltip tooltip={text} placement={placement} id={id}>
      <button
        type="button"
        aria-label="More info"
        className={className}
        style={{ cursor: 'pointer', marginLeft: 6, padding: 0, border: 'none', background: 'none' }}
      >
        <i className="fa fa-info-circle text-muted" aria-hidden="true" />
      </button>
    </CustomTooltip>
  )
}

InfoTooltip.propTypes = {
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  placement: PropTypes.oneOf(['top', 'right', 'bottom', 'left']),
  id: PropTypes.string,
  className: PropTypes.string,
}

export default InfoTooltip 
